import { styled } from '@mui/system';
import { useDrawingArea } from '@mui/x-charts/hooks';
import { bloxChartColors } from '../../../../themes/constants';

const StyledText = styled('text')(({ theme }) => ({
  fill:
    theme.palette.mode === 'light' ? bloxChartColors.gray : theme.palette.text.secondary,
  textAnchor: 'middle',
  dominantBaseline: 'central',
  textTransform: 'capitalize',
}));

export default function PieCenterLabel({
  children,
  isTopLabel = false,
}: {
  children: React.ReactNode;
  isTopLabel?: boolean;
}) {
  const { width, height, left, top } = useDrawingArea();
  const topLabelFontSize = width <= 200 ? 24 : 50;
  const bottomLabelFontSize = width <= 200 ? 16 : 20;

  return (
    <StyledText
      x={left + width / 2}
      y={top + height / (isTopLabel ? 2.25 : 1.75)}
      sx={{
        fontWeight: 'bold',
        fontSize: isTopLabel ? topLabelFontSize : bottomLabelFontSize,
      }}
    >
      {children}
    </StyledText>
  );
}
